import { createSlice } from '@reduxjs/toolkit'

export const deviceInfoSlice = createSlice({
    name: 'deviceInfo',
    initialState: {
        info: {
            deviceId: '', // 디바이스 아이디
			deviceType: '', // 디바이스 타입
			notificationToken: '', // 푸시 토큰
        },
    },
    reducers: {
        setDeviceInfo: (state, actions) => {
            state.info = actions.payload
        },
        removeDeviceInfo: (state) => {
            state.info = {
                deviceId: '', // 디바이스 아이디
                deviceType: '', // 디바이스 타입
                notificationToken: '', // 푸시 토큰
            }
        }
    }
})

export const { setDeviceInfo, removeDeviceInfo } = deviceInfoSlice.actions
export default deviceInfoSlice.reducer
export const selectDeviceInfo = (state: any) => state.deviceInfo.info